import React from 'react';
import TrainSchedule from './components/TrainSchedule';

function App() {
  return (
    <div className="app">
      <TrainSchedule />
    </div>
  );
}

export default App;
